<!-- Component for displaying data in the format:   dataLabel : data
  -- Label and it's associated data will always be on separate lines. -->
<template>
  <div class="row">
    <div class="field-label col-12 font-weight-bold">
      {{ fieldLabel }}
    </div>
    <div class="field-value col-12">
      <div class="pad-top" :id="setDisplayPropId()">
        <slot>{{ defaultValue }}</slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailField',
  props: {
    fieldLabel: {
      type: String,
      required: true,
    },
    defaultValue: {
      type: String,
      required: false,
      default: 'Not Set',
    },
  },
  methods: {
    setDisplayPropId() {
      if (this.defaultValue === 'Not Set' && this.fieldLabel === 'Display Name') {
        return 'fld-no-display-name';
      }
      if (this.defaultValue === 'Not Set' && this.fieldLabel === 'Group Contact Email Address') {
        return 'fld-no-email-address';
      }
    },
  },
};
</script>

<style scoped>
  .field-label {
    font-size: 1.1rem;
  }
  .field-value {
    font-size: 1rem;
  }
  .pad-top {
    padding-top: .5em;
  }
</style>



// WEBPACK FOOTER //
// src/components/slots/DetailField.vue